<template>
    <div class="aboutusall">
      <div>
        <div class="hero">
              <div>
                <b-img :src="require('@/assets/aboutus_p1_720.png')" class="hero-image" />
              </div>
        </div>
        <div class="tp1">
          <div class="tp1_d">
            <div class="tp1_d_1">About On Call Care Diabetes</div>
            <div class="tp1_d_2">Our vision at On Call Care Diabetes is to dedicate ourselves to providing digital solutions for diabetes patients worldwide, assisting them in effectively managing their diabetes and improving their quality of life.</div>
            <div class="tp1_d_3">Diabetes management is a comprehensive process that involves adjusting lifestyle, medication treatment, regular<br> check-ups, and the prevention and treatment of complications. Our digital solutions are dedicated to patient care, streamlining workflows to achieve more efficient and focused patient care, significantly reducing manual paperwork, and enhancing overall operational efficiency.</div>
            <div class="tp1_d_4">With a deep understanding of diabetes management and the advantage of years of product development experience, Aike has become a top brand recommended by healthcare professionals and chronic disease educators worldwide</div>
            <div class="tp1_d_5">Keeping health always online is the promise Aike makes to its patients. We establish deep cooperation with medical institutions at all levels and major chain pharmacies to promote the digital management of diabetes patients, serving every patient with a scientific attitude, professional standards, and a standardized system</div>
          </div>
          <div class="tp1_i">
            <b-img :src="require('@/assets/aboutus_p2.svg')" class="tp1-image" />
          </div>
        </div>
        <div class="tp2">
          <div class="tp2_d_1">About ACON</div>
        <div class="tp2_dd">
          <div class="tp2_d_2">ACON Biotechnology (Hangzhou) Co., Ltd., established in 1995, relies on the strength of biological technology R&D from China and the United States, a rigorous quality control system, and a global sales cooperation strategy to serve the global human health field. The company is committed to the development of raw materials in the field of biological diagnostics, R&D of diagnostic products, production and sales, and integrated services, providing a complete solution in the medical field for global customers.</div>
          <div class="tp2_d_3">Technical Platform and Service Area</div>
          <div class="tp2_d_4">The company has accumulated R&D talents from both China and the United States, successfully building various dry chemical platforms, immunodiagnostic platforms, molecular diagnostic platforms, as well as platforms for medical devices and biological raw materials. It continuously enriches the menu of medical testing needs in the fields of endocrine diseases, infectious diseases, eugenics, oncology, and genetic diseases, and continues to serve medical institutions such as various hospital systems, blood centers, disease control centers, and independent hospital laboratories.</div>
          <div class="tp2_d_5">Quality System and Management Capability</div>
          <div class="tp2_d_6">For more than twenty years, as the company's scale has continued to expand, the production base has been relocated and expanded. On the journey of change, with strong independent innovation capabilities and efficient management capabilities, the company has repeatedly passed authoritative certifications such as the China Food and Drug Administration, the U.S. FDA, the European CE, and ISO13485 at home and abroad, and has successively obtained more than 140 diagnostic product licenses for various platforms. Adhering to the principle of quality first, serving customer groups.</div>
          <div class="tp2_d_7">Global Manufacturing and Sales System</div>
          <div class="tp2_d_8">The company gathers global industrial resources and, based on a standardized quality system, has established multiple R&D and manufacturing industrialization bases in China, the United States, and Mexico. Billions of test reagents and millions of instruments are produced annually, and through a global marketing cooperation network, it provides product solutions and technical support services to customers in 148 countries and regions around the world through a variety of communication modes.</div>
          <div class="tp2_d_9">Brand Development</div>
          <div class="tp2_d_10">The company takes immunochromatography technology as the original force for entrepreneurship, and the brand image has evolved from this, carrying the beautiful wish to serve human health and life. With the continuous development and expansion of the company's business, ACON has now grown into a full product solution and service provider in the IVD field, with sub-brands such as Mission®, Promotor®, Foresight®, and Flowflex® derived from biochemical, molecular, immunological, and rapid diagnostic technology platforms. At the same time, it deeply cultivates and deploys in the sub-fields, and has a strong brand in the POCT chronic disease management category - Aike® (On•Call®), and a brand serving women's cervical health - Cermiss®.</div>
          <div class="tp2_d_11">For more information, please visit <a href="http://www.acondiabetescare.com/" target="_blank">http://www.acondiabetescare.com/</a></div>
        </div>
        </div>
        <!-- <div class="footer">
            <b-container fluid class="footertxt">
                <b-row>
                        <ul class="footer-links">
                          <li><a style="color:#6c757d;">About This Website</a></li>
                            <li><a style="color:#6c757d;">Website Disclaimer</a></li>
                            <li><a style="color:#6c757d;">Legal Disclaimer</a></li>
                            <li><a style="color:#6c757d;">Privacy Policy</a></li>
                            <li><a style="color:#6c757d;">Contact Us</a></li>
                        </ul>
                    
                        <div class="footer-description">
                        <hr class="footer-line" />
                        <p>This website contains product information aimed at a broad audience and may include details or information on products that are not accessible or valid in your country/region. Please note that we assume no responsibility for accessing such information, which may not comply with any legal procedures, regulations, registrations, or uses in your country of origin.</p>
                        <a href="https://beian.miit.gov.cn/" style="color:#6c757d;">浙ICP备05049929号-15<br></a>
                        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=33010602013521" rel="noreferrer" target="_blank" style="color:#6c757d;">浙公网安备33010602013521</a>
                        
                        </div>
                    
                </b-row>
            </b-container>
          </div>-->
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'AboutUs'
  }
  </script>
  
  <style scoped>
  .aboutusall{
    min-width: 1200px;
  }

  .hero {
    position: relative;
    width: 100%;
    overflow: hidden;
  }

  .hero-image{
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .footer {
  background-color: #f8f9fa;
  padding: 0px 0;
}

.footer-links {
  display: flex;
  justify-content: space-around; /* 链接均匀分布 */
  flex-wrap: wrap; /* 当屏幕较小时，链接会换行 */
  padding: 0;
  list-style-type: none;
}

.footer-links a {
  text-decoration: none;
  color: #007bff;
  margin: 0 10px; /* 添加左右间距 */
}

.footer-links a:hover {
  text-decoration: underline;
}

.footer-description {
  text-align: center;
}

.footer-line {
  border: 1px solid #dee2e6;
  margin: 20px 0;
}

.footer-description p {
  margin-top: 10px;
  color: #6c757d;
}
.footertxt{
    background-color: #F4F7FC;
    padding: 30px;
    padding-top: 100px;
  }
  .tp1{
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
    padding-top: 91px;
  }
  .tp1_d_1{
    font-family: Arial;
    font-size: 40px;
    font-weight: 700;
    line-height: 48px;
    text-align: left;
    padding-bottom: 56px;
  }
  .tp1_d_2{
    font-family: Arial;
font-size: 20px;
font-weight: 400;
line-height: 32px;
text-align: left;
width: 673px;
color: #333333;
padding-bottom: 40px;
  }
  .tp1_d_3{
    font-family: Arial;
font-size: 20px;
font-weight: 400;
line-height: 32px;
text-align: left;
width: 972px;
color: #333333;
padding-bottom: 40px;
  }
  .tp1_d_4{
    font-family: Arial;
font-size: 20px;
font-weight: 400;
line-height: 32px;
text-align: left;
width:1178px ;
color: #333333;
padding-bottom: 40px;
  }
  .tp1_d_5{
    font-family: Arial;
font-size: 20px;
font-weight: 400;
line-height: 32px;
text-align: left;
width: 1178px;
color: #333333;
  }
  .tp1_d{
    z-index: 3;
  }
.tp1_i{
  margin-left: -490px;
  margin-top: -140px;
  z-index: 2;
}
.tp2{
  display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
  .tp2_dd{

    padding-top: 56px;
  }
  .tp2_d_1{
    font-family: Arial;
font-size: 40px;
font-weight: 700;
line-height: 48px;
text-align: center;
padding-top: 96px;
  }
  .tp2_d_2{
    font-family: Arial;
font-size: 18px;
font-weight: 400;
line-height: 32px;
text-align: left;
color: #555555;
width: 1200px;

  }
  .tp2_d_3{
    font-family: Arial;
font-size: 18px;
font-weight: 700;
line-height: 32px;
text-align: left;
padding-top: 28px;
  }
  .tp2_d_4{
    font-family: Arial;
font-size: 18px;
font-weight: 400;
line-height: 32px;
text-align: left;
color: #555555;
width: 1200px;
padding-top: 28px;
  }
  .tp2_d_5{
    font-family: Arial;
font-size: 18px;
font-weight: 700;
line-height: 32px;
text-align: left;
padding-top: 28px;
  }
  .tp2_d_6{
    font-family: Arial;
font-size: 18px;
font-weight: 400;
line-height: 32px;
text-align: left;
color: #555555;
width: 1200px;
padding-top: 28px;
  }
  .tp2_d_7{
    font-family: Arial;
font-size: 18px;
font-weight: 700;
line-height: 32px;
text-align: left;
padding-top: 28px;
  }
  .tp2_d_8{
    font-family: Arial;
font-size: 18px;
font-weight: 400;
line-height: 32px;
text-align: left;
color: #555555;
width: 1200px;
padding-top: 28px;
  }
  .tp2_d_9{
    font-family: Arial;
font-size: 18px;
font-weight: 700;
line-height: 32px;
text-align: left;
padding-top: 28px;
  }
  .tp2_d_10{
    font-family: Arial;
font-size: 18px;
font-weight: 400;
line-height: 32px;
text-align: left;
color: #555555;
width: 1200px;
padding-top: 28px;
  }
  .tp2_d_11{
    font-family: Source Sans 3;
font-size: 16px;
font-weight: 400;
line-height: 30px;
text-align: left;
padding-top: 40px;
margin-bottom: 96px;
color: #555555;
  }

  </style>